/**
 * Parse a date value from a string
 * @param value - The string to parse
 * @returns The date value
 */
export const parseDate = (value: string): Date | null => {
  const dateValue = new Date(value);
  if (!isNaN(dateValue.getTime()) && value.match(/^\d{4}-\d{2}-\d{2}/)) {
    return dateValue;
  }
  return null;
};
